export default __webpack_public_path__ + "static/media/card-leaderboard-sweepstakes.5fb5ffbe.jpg";